<template>
  <footer class="footer center-footer">
    <div class="footer__images">
      <img
        src="../assets/img/grass_1.svg"
        alt="Grass 1"
        class="footer__image_grass_1"
      />
      <img src="../assets/img/cart.svg" alt="Cart" class="footer__image_cart" />

      <img
        src="../assets/img/grass_2.svg"
        alt="Grass 2"
        class="footer__image_grass_2"
      />
      <img
        src="../assets/img/grass_3.svg"
        alt="Grass 3"
        class="footer__image_grass_3"
      />
      <img
        src="../assets/img/grass_4.svg"
        alt="Grass 4"
        class="footer__image_grass_4"
      />
    </div>
    <div class="footer__main">
      <div class="footer__contacts">
        <div class="footer__contact_info" id="contacts">
          <h5 class="footer__contacts_title">{{ $t("footer.contact_us") }}</h5>
          <ul class="footer__contacts_list">
            <li class="footer__contacts_item">
              <p class="footer__contacts_text">
                <!-- <a href="tel:+49 17667484911">+49 17667484911</a> -->
              </p>
            </li>
            <li class="footer__contacts_item">
              <p class="footer__contacts_text">
                <a href="mailto:ac(at)foodfutures.net "
                  >ac(at)foodfutures.net
                </a>
              </p>
            </li>
            <li class="footer__contacts_item">
              <a
                href="https://maps.google.com/?q=Mikonkatu 8 A, 00100 HELSINKI Finland"
                target="_blank"
                class="footer__contacts_text"
                >Discovery Freshness Club</a
              >
            </li>
          </ul>
        </div>
        <ul class="footer__links">
          <li class="footer__links_item">
            <a
              href="https://x.com/i/flow/login?redirect_after_login=%2FUncoClub"
              target="_blank"
              class="svg-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                class="svg-icon"
              >
                <path
                  d="M30.0938 1H9.90625C4.98746 1 1 4.98746 1 9.90625V30.0938C1 35.0125 4.98746 39 9.90625 39H30.0938C35.0125 39 39 35.0125 39 30.0938V9.90625C39 4.98746 35.0125 1 30.0938 1Z"
                  fill="var(--color1, #FEFFFA)"
                />
                <path
                  d="M30.625 0H9.375C4.19733 0 0 4.19733 0 9.375V30.625C0 35.8027 4.19733 40 9.375 40H30.625C35.8027 40 40 35.8027 40 30.625V9.375C40 4.19733 35.8027 0 30.625 0Z"
                  fill="var(--color2, #BC0051)"
                />
                <path
                  d="M31.1831 14.283C31.2003 14.5309 31.2003 14.7789 31.2003 15.0292C31.2003 22.6537 25.3959 31.4472 14.7823 31.4472V31.4425C11.6469 31.447 8.57641 30.549 5.9375 28.8558C6.39344 28.9106 6.85156 28.938 7.31094 28.9391C9.90968 28.9411 12.4337 28.0695 14.4773 26.4642C13.2732 26.4415 12.1064 26.043 11.1398 25.3246C10.1733 24.6061 9.4554 23.6036 9.08656 22.4572C9.95106 22.6239 10.8423 22.5899 11.6916 22.3578C8.99969 21.8139 7.06297 19.4487 7.06297 16.7019V16.6287C7.86546 17.0757 8.76356 17.3234 9.68172 17.3509C7.14641 15.6564 6.36484 12.2834 7.89578 9.64624C9.34442 11.4289 11.1519 12.8869 13.2007 13.9255C15.2495 14.9641 17.4939 15.56 19.7881 15.6747C19.5594 14.6901 19.5932 13.6626 19.8861 12.6952C20.179 11.7277 20.7208 10.8541 21.4573 10.1617C23.7814 7.97702 27.4366 8.08906 29.6213 10.4119C30.9134 10.1567 32.1526 9.68302 33.2855 9.01109C32.8547 10.3471 31.9533 11.4812 30.7489 12.2023C31.8928 12.0676 33.0098 11.7614 34.0625 11.2941C33.2881 12.4537 32.3131 13.4658 31.1831 14.283Z"
                  fill="var(--color1, #FEFFFA)"
                />
              </svg>
            </a>
          </li>
          <li class="footer__links_item">
            <a
              href="https://t.me/UNCOFOODFUTURES_eng"
              target="_blank"
              class="svg-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                class="svg-icon"
              >
                <path
                  d="M28.514 9.14367C28.8091 9.01646 29.1321 8.97258 29.4493 9.01661C29.7666 9.06064 30.0665 9.19096 30.3179 9.39401C30.5693 9.59706 30.763 9.86542 30.8788 10.1711C30.9946 10.4769 31.0282 10.8088 30.9762 11.1324L28.268 27.9581C28.0053 29.5811 26.2667 30.5118 24.8135 29.7034C23.5979 29.027 21.7924 27.985 20.1684 26.8977C19.3564 26.3534 16.8691 24.6106 17.1748 23.3704C17.4375 22.31 21.6169 18.3252 24.0051 15.9561C24.9424 15.0254 24.515 14.4885 23.408 15.3446C20.6592 17.4703 16.2458 20.7029 14.7866 21.6128C13.4994 22.4152 12.8283 22.5521 12.0258 22.4152C10.5619 22.1656 9.20418 21.7792 8.09605 21.3083C6.59865 20.6723 6.67149 18.5637 8.09486 17.9497L28.514 9.14367Z"
                  fill="var(--color1, #FEFFFA)"
                />
                <path
                  d="M30.625 0H9.375C4.19733 0 0 4.19733 0 9.375V30.625C0 35.8027 4.19733 40 9.375 40H30.625C35.8027 40 40 35.8027 40 30.625V9.375C40 4.19733 35.8027 0 30.625 0Z"
                  fill="var(--color2, #BC0051)"
                />
                <path
                  d="M28.514 9.14367C28.8091 9.01646 29.1321 8.97258 29.4493 9.01661C29.7666 9.06064 30.0665 9.19096 30.3179 9.39401C30.5693 9.59706 30.763 9.86542 30.8788 10.1711C30.9946 10.4769 31.0282 10.8088 30.9762 11.1324L28.268 27.9581C28.0053 29.5811 26.2667 30.5118 24.8135 29.7034C23.5979 29.027 21.7924 27.985 20.1684 26.8977C19.3564 26.3534 16.8691 24.6106 17.1748 23.3704C17.4375 22.31 21.6169 18.3252 24.0051 15.9561C24.9424 15.0254 24.515 14.4885 23.408 15.3446C20.6592 17.4703 16.2458 20.7029 14.7866 21.6128C13.4994 22.4152 12.8283 22.5521 12.0258 22.4152C10.5619 22.1656 9.20418 21.7792 8.09605 21.3083C6.59865 20.6723 6.67149 18.5637 8.09486 17.9497L28.514 9.14367Z"
                  fill="var(--color1, #FEFFFA)"
                />
              </svg>
            </a>
          </li>
          <li class="footer__links_item">
            <a
              href="https://www.linkedin.com/company/unco-club"
              target="_blank"
              class="svg-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                class="svg-icon"
              >
                <path
                  d="M30.0938 1H9.90625C4.98746 1 1 4.98746 1 9.90625V30.0938C1 35.0125 4.98746 39 9.90625 39H30.0938C35.0125 39 39 35.0125 39 30.0938V9.90625C39 4.98746 35.0125 1 30.0938 1Z"
                  fill="var(--color1, #FEFFFA)"
                />
                <path
                  d="M30.625 0H9.375C4.19733 0 0 4.19733 0 9.375V30.625C0 35.8027 4.19733 40 9.375 40H30.625C35.8027 40 40 35.8027 40 30.625V9.375C40 4.19733 35.8027 0 30.625 0Z"
                  fill="var(--color2, #BC0051)"
                />
                <path
                  d="M28.8617 34.0133H33.4352C33.6009 34.0133 33.7598 33.9475 33.877 33.8303C33.9942 33.7131 34.0601 33.5542 34.0602 33.3884L34.0625 23.7256C34.0625 18.6752 32.9742 14.7931 27.0722 14.7931C24.8286 14.7097 22.7128 15.8663 21.5711 17.7975C21.5655 17.8069 21.557 17.8142 21.5469 17.8183C21.5368 17.8224 21.5256 17.8231 21.5151 17.8202C21.5045 17.8173 21.4952 17.8111 21.4885 17.8025C21.4819 17.7938 21.4782 17.7833 21.4781 17.7723V15.8844C21.4781 15.7186 21.4123 15.5596 21.2951 15.4424C21.1779 15.3252 21.0189 15.2594 20.8531 15.2594H16.513C16.3472 15.2594 16.1882 15.3252 16.071 15.4424C15.9538 15.5596 15.888 15.7186 15.888 15.8844V33.3875C15.888 33.5533 15.9538 33.7122 16.071 33.8294C16.1882 33.9467 16.3472 34.0125 16.513 34.0125H21.0861C21.2519 34.0125 21.4108 33.9467 21.528 33.8294C21.6452 33.7122 21.7111 33.5533 21.7111 33.3875V24.7355C21.7111 22.2891 22.1752 19.9198 25.2081 19.9198C28.198 19.9198 28.2367 22.7192 28.2367 24.8939V33.3883C28.2367 33.554 28.3026 33.713 28.4198 33.8302C28.537 33.9474 28.696 34.0133 28.8617 34.0133ZM5.9375 9.31687C5.9375 11.1706 7.46359 12.6959 9.3175 12.6959C11.1709 12.6958 12.6961 11.1695 12.6961 9.31609C12.6958 7.46266 11.1705 5.9375 9.31687 5.9375C7.46281 5.9375 5.9375 7.46312 5.9375 9.31687ZM7.02484 34.0133H11.6041C11.7698 34.0133 11.9288 33.9474 12.046 33.8302C12.1632 33.713 12.2291 33.554 12.2291 33.3883V15.8844C12.2291 15.7186 12.1632 15.5596 12.046 15.4424C11.9288 15.3252 11.7698 15.2594 11.6041 15.2594H7.02484C6.85908 15.2594 6.70011 15.3252 6.5829 15.4424C6.46569 15.5596 6.39984 15.7186 6.39984 15.8844V33.3883C6.39984 33.554 6.46569 33.713 6.5829 33.8302C6.70011 33.9474 6.85908 34.0133 7.02484 34.0133Z"
                  fill="var(--color1, #FEFFFA)"
                />
              </svg>
            </a>
          </li>
          <li class="footer__links_item">
            <a
              href="https://www.linkedin.com/company/unco-club"
              target="_blank"
              class="svg-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                class="svg-icon"
              >
                <path
                  d="M30.8293 10.1245C28.8033 9.19445 26.6652 8.53126 24.4685 8.15151C24.4485 8.14782 24.4279 8.15051 24.4096 8.15921C24.3912 8.1679 24.3761 8.18216 24.3663 8.19995C24.0916 8.68839 23.7872 9.32589 23.5743 9.82683C21.1722 9.46714 18.7827 9.46714 16.4301 9.82683C16.2169 9.31464 15.9016 8.68839 15.6257 8.19995C15.6155 8.18253 15.6002 8.16858 15.582 8.15994C15.5637 8.1513 15.5433 8.14836 15.5233 8.15151C13.3265 8.53049 11.1883 9.19372 9.16256 10.1245C9.14522 10.1318 9.13059 10.1444 9.12069 10.1604C5.06944 16.2129 3.95975 22.1167 4.50412 27.9473C4.50564 27.9616 4.51002 27.9754 4.517 27.988C4.52398 28.0006 4.53341 28.0116 4.54475 28.0204C7.21756 29.9834 9.80678 31.1751 12.3479 31.965C12.3676 31.9708 12.3887 31.9706 12.4083 31.9641C12.4279 31.9577 12.4451 31.9455 12.4576 31.929C13.0587 31.1081 13.5944 30.2426 14.054 29.3325C14.0603 29.32 14.0639 29.3063 14.0646 29.2924C14.0652 29.2784 14.0629 29.2644 14.0578 29.2514C14.0527 29.2384 14.0449 29.2267 14.0348 29.2169C14.0248 29.2071 14.0129 29.1996 13.9997 29.1948C13.1497 28.8723 12.3405 28.4793 11.5621 28.0329C11.5479 28.0246 11.536 28.0129 11.5274 27.9988C11.5188 27.9848 11.5138 27.9688 11.5129 27.9524C11.5119 27.936 11.515 27.9196 11.5218 27.9046C11.5287 27.8897 11.5392 27.8766 11.5522 27.8667C11.7165 27.7439 11.8779 27.6174 12.0363 27.4873C12.0502 27.4758 12.067 27.4685 12.0848 27.466C12.1027 27.4636 12.1208 27.4662 12.1372 27.4735C17.2516 29.8085 22.7883 29.8085 27.8422 27.4735C27.8587 27.4657 27.8771 27.4628 27.8952 27.465C27.9133 27.4672 27.9305 27.4745 27.9446 27.486C28.1032 27.6169 28.265 27.7438 28.4299 27.8667C28.4431 27.8765 28.4536 27.8895 28.4606 27.9044C28.4675 27.9193 28.4707 27.9357 28.4699 27.9521C28.469 27.9685 28.4642 27.9845 28.4557 27.9986C28.4472 28.0127 28.4354 28.0245 28.4213 28.0329C27.6424 28.4877 26.8266 28.876 25.9824 29.1935C25.9693 29.1986 25.9574 29.2063 25.9475 29.2162C25.9376 29.2261 25.9298 29.238 25.9248 29.2511C25.9198 29.2643 25.9177 29.2783 25.9185 29.2923C25.9192 29.3063 25.923 29.32 25.9294 29.3325C26.3969 30.2354 26.93 31.1028 27.5244 31.9278C27.5365 31.9447 27.5536 31.9573 27.5733 31.964C27.593 31.9707 27.6142 31.971 27.6341 31.965C30.1876 31.1751 32.7768 29.9834 35.4497 28.0204C35.4612 28.012 35.4707 28.0012 35.4777 27.9888C35.4847 27.9764 35.4891 27.9627 35.4904 27.9485C36.1419 21.2078 34.399 15.3523 30.8699 10.1617C30.8613 10.1448 30.8468 10.1316 30.8293 10.1245ZM14.8177 24.3971C13.2779 24.3971 12.0091 22.9835 12.0091 21.2475C12.0091 19.5114 13.2533 18.0978 14.8177 18.0978C16.3943 18.0978 17.6507 19.5239 17.626 21.2475C17.626 22.9835 16.3819 24.3971 14.8177 24.3971ZM25.2015 24.3971C23.6616 24.3971 22.393 22.9835 22.393 21.2475C22.393 19.5114 23.6371 18.0978 25.2015 18.0978C26.778 18.0978 28.0344 19.5239 28.0099 21.2475C28.0099 22.9835 26.778 24.3971 25.2015 24.3971Z"
                  fill="var(--color1, #FEFFFA)"
                />
                <path
                  d="M30.625 0H9.375C4.19733 0 0 4.19733 0 9.375V30.625C0 35.8027 4.19733 40 9.375 40H30.625C35.8027 40 40 35.8027 40 30.625V9.375C40 4.19733 35.8027 0 30.625 0Z"
                  fill="var(--color2, #BC0051)"
                />
                <path
                  d="M30.8293 10.1245C28.8033 9.19445 26.6652 8.53126 24.4685 8.15151C24.4485 8.14782 24.4279 8.15051 24.4096 8.15921C24.3912 8.1679 24.3761 8.18216 24.3663 8.19995C24.0916 8.68839 23.7872 9.32589 23.5743 9.82683C21.1722 9.46714 18.7827 9.46714 16.4301 9.82683C16.2169 9.31464 15.9016 8.68839 15.6257 8.19995C15.6155 8.18253 15.6002 8.16858 15.582 8.15994C15.5637 8.1513 15.5433 8.14836 15.5233 8.15151C13.3265 8.53049 11.1883 9.19372 9.16256 10.1245C9.14522 10.1318 9.13059 10.1444 9.12069 10.1604C5.06944 16.2129 3.95975 22.1167 4.50412 27.9473C4.50564 27.9616 4.51002 27.9754 4.517 27.988C4.52398 28.0006 4.53341 28.0116 4.54475 28.0204C7.21756 29.9834 9.80678 31.1751 12.3479 31.965C12.3676 31.9708 12.3887 31.9706 12.4083 31.9641C12.4279 31.9577 12.4451 31.9455 12.4576 31.929C13.0587 31.1081 13.5944 30.2426 14.054 29.3325C14.0603 29.32 14.0639 29.3063 14.0646 29.2924C14.0652 29.2784 14.0629 29.2644 14.0578 29.2514C14.0527 29.2384 14.0449 29.2267 14.0348 29.2169C14.0248 29.2071 14.0129 29.1996 13.9997 29.1948C13.1497 28.8723 12.3405 28.4793 11.5621 28.0329C11.5479 28.0246 11.536 28.0129 11.5274 27.9988C11.5188 27.9848 11.5138 27.9688 11.5129 27.9524C11.5119 27.936 11.515 27.9196 11.5218 27.9046C11.5287 27.8897 11.5392 27.8766 11.5522 27.8667C11.7165 27.7439 11.8779 27.6174 12.0363 27.4873C12.0502 27.4758 12.067 27.4685 12.0848 27.466C12.1027 27.4636 12.1208 27.4662 12.1372 27.4735C17.2516 29.8085 22.7883 29.8085 27.8422 27.4735C27.8587 27.4657 27.8771 27.4628 27.8952 27.465C27.9133 27.4672 27.9305 27.4745 27.9446 27.486C28.1032 27.6169 28.265 27.7438 28.4299 27.8667C28.4431 27.8765 28.4536 27.8895 28.4606 27.9044C28.4675 27.9193 28.4707 27.9357 28.4699 27.9521C28.469 27.9685 28.4642 27.9845 28.4557 27.9986C28.4472 28.0127 28.4354 28.0245 28.4213 28.0329C27.6424 28.4877 26.8266 28.876 25.9824 29.1935C25.9693 29.1986 25.9574 29.2063 25.9475 29.2162C25.9376 29.2261 25.9298 29.238 25.9248 29.2511C25.9198 29.2643 25.9177 29.2783 25.9185 29.2923C25.9192 29.3063 25.923 29.32 25.9294 29.3325C26.3969 30.2354 26.93 31.1028 27.5244 31.9278C27.5365 31.9447 27.5536 31.9573 27.5733 31.964C27.593 31.9707 27.6142 31.971 27.6341 31.965C30.1876 31.1751 32.7768 29.9834 35.4497 28.0204C35.4612 28.012 35.4707 28.0012 35.4777 27.9888C35.4847 27.9764 35.4891 27.9627 35.4904 27.9485C36.1419 21.2078 34.399 15.3523 30.8699 10.1617C30.8613 10.1448 30.8468 10.1316 30.8293 10.1245ZM14.8177 24.3971C13.2779 24.3971 12.0091 22.9835 12.0091 21.2475C12.0091 19.5114 13.2533 18.0978 14.8177 18.0978C16.3943 18.0978 17.6507 19.5239 17.626 21.2475C17.626 22.9835 16.3819 24.3971 14.8177 24.3971ZM25.2015 24.3971C23.6616 24.3971 22.393 22.9835 22.393 21.2475C22.393 19.5114 23.6371 18.0978 25.2015 18.0978C26.778 18.0978 28.0344 19.5239 28.0099 21.2475C28.0099 22.9835 26.778 24.3971 25.2015 24.3971Z"
                  fill="var(--color1, #FEFFFA)"
                />
              </svg>
            </a>
          </li>
          <li class="footer__links_item">
            <a
              href="https://www.youtube.com/@UNCOFoodFutures"
              target="_blank"
              class="svg-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                class="svg-icon"
              >
                <path
                  d="M34.0442 14.2968C33.9103 13.28 33.522 12.3135 32.9153 11.4866C32.1634 10.7292 31.1437 10.298 30.0765 10.2862C26.1174 10 20.1666 10 20.1666 10C20.1666 10 14.2187 10 10.2538 10.2862C9.18716 10.2984 8.16806 10.7296 7.41652 11.4866C6.80575 12.3119 6.41659 13.2798 6.28617 14.2982C6.10892 15.8211 6.0134 17.3523 6 18.8854V21.0317C6.0134 22.5648 6.10892 24.096 6.28617 25.6189C6.42066 26.6377 6.80699 27.6078 7.40793 28.4405C8.27215 29.2074 9.38247 29.6381 10.5372 29.6538C12.8022 29.8699 20.168 29.94 20.168 29.94C20.168 29.94 26.1217 29.94 30.0808 29.6538C31.1487 29.642 32.169 29.2102 32.921 28.4519C33.5248 27.6232 33.9119 26.6567 34.0471 25.6404C34.2243 24.1175 34.3198 22.5862 34.3332 21.0531V18.884C34.3162 17.351 34.2198 15.8198 34.0442 14.2968ZM17.315 23.6744V15.6332L25.0414 19.6667L17.315 23.6744Z"
                  fill="var(--color1, #FEFFFA)"
                />
                <path
                  d="M30.625 0H9.375C4.19733 0 0 4.19733 0 9.375V30.625C0 35.8027 4.19733 40 9.375 40H30.625C35.8027 40 40 35.8027 40 30.625V9.375C40 4.19733 35.8027 0 30.625 0Z"
                  fill="var(--color2, #BC0051)"
                />
                <path
                  d="M34.0442 14.2968C33.9103 13.28 33.522 12.3135 32.9153 11.4866C32.1634 10.7292 31.1437 10.298 30.0765 10.2862C26.1174 10 20.1666 10 20.1666 10C20.1666 10 14.2187 10 10.2538 10.2862C9.18716 10.2984 8.16806 10.7296 7.41652 11.4866C6.80575 12.3119 6.41659 13.2798 6.28617 14.2982C6.10892 15.8211 6.0134 17.3523 6 18.8854V21.0317C6.0134 22.5648 6.10892 24.096 6.28617 25.6189C6.42066 26.6377 6.80699 27.6078 7.40793 28.4405C8.27215 29.2074 9.38247 29.6381 10.5372 29.6538C12.8022 29.8699 20.168 29.94 20.168 29.94C20.168 29.94 26.1217 29.94 30.0808 29.6538C31.1487 29.642 32.169 29.2102 32.921 28.4519C33.5248 27.6232 33.9119 26.6567 34.0471 25.6404C34.2243 24.1175 34.3198 22.5862 34.3332 21.0531V18.884C34.3162 17.351 34.2198 15.8198 34.0442 14.2968ZM17.315 23.6744V15.6332L25.0414 19.6667L17.315 23.6744Z"
                  fill="var(--color1, #FEFFFA)"
                />
              </svg>
            </a>
          </li>
          <li class="footer__links_item">
            <a
              href="https://www.facebook.com/unco.club.de"
              target="_blank"
              class="svg-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                class="svg-icon"
              >
                <g clip-path="url(#clip0_442_203)">
                  <rect
                    width="40"
                    height="40"
                    rx="10"
                    fill="var(--color1, #FEFFFA)"
                  />
                  <path
                    d="M30.736 0.000184676H9.21885C7.99961 0.000205641 6.79241 0.241247 5.66665 0.709449C4.54089 1.17765 3.51878 1.86378 2.65909 2.72838C1.80344 3.59112 1.12779 4.61534 0.671421 5.7415C0.215056 6.86766 -0.0129248 8.0733 0.000730965 9.28835V30.7118C-0.0146402 31.9271 0.212555 33.1333 0.669017 34.2597C1.12548 35.3861 1.80204 36.4101 2.65909 37.2718C3.51744 38.1376 4.53901 38.8246 5.66465 39.2929C6.79029 39.7612 7.99764 40.0015 9.2168 40H18.9867V25.7108H15.2535C15.0221 25.7103 14.8002 25.6184 14.6362 25.4551C14.4722 25.2919 14.3793 25.0705 14.3776 24.839V20.2524C14.3774 20.1345 14.4004 20.0178 14.4455 19.9089C14.4907 19.8 14.5569 19.7011 14.6404 19.6179C14.724 19.5348 14.8231 19.469 14.9322 19.4244C15.0413 19.3798 15.1582 19.3572 15.2761 19.358H18.9867V14.8863C18.8826 13.8294 19.0117 12.7626 19.3646 11.761C19.7176 10.7594 20.286 9.84744 21.0297 9.08937C21.7744 8.32821 22.676 7.73847 23.6718 7.36119C24.6675 6.98391 25.7336 6.82816 26.7956 6.90477H30.5986C30.7151 6.90502 30.8304 6.92846 30.9377 6.97373C31.0451 7.01899 31.1424 7.08517 31.2239 7.16842C31.3054 7.25166 31.3696 7.3503 31.4126 7.45858C31.4556 7.56686 31.4766 7.68263 31.4744 7.79912V11.676C31.4744 11.7908 31.4517 11.9044 31.4076 12.0103C31.3636 12.1162 31.2989 12.2124 31.2175 12.2932C31.1361 12.3741 31.0395 12.438 30.9333 12.4813C30.8271 12.5247 30.7133 12.5466 30.5986 12.5458H28.2951C25.7598 12.5458 25.2757 13.7396 25.2757 15.4811V19.3355H30.8057C30.9304 19.3348 31.0538 19.3608 31.1677 19.4115C31.2815 19.4623 31.3833 19.5367 31.4661 19.6299C31.549 19.723 31.6111 19.8328 31.6482 19.9518C31.6854 20.0708 31.6968 20.1963 31.6816 20.3201L31.1278 24.9088C31.1053 25.1245 31.003 25.3241 30.8409 25.4683C30.6789 25.6125 30.4688 25.691 30.2519 25.6883H25.2983V39.9774H30.7832C32.0021 39.9772 33.2089 39.7361 34.3343 39.2679C35.4598 38.7997 36.4815 38.1137 37.3409 37.2492C38.1967 36.3862 38.8724 35.3616 39.3288 34.2351C39.7852 33.1086 40.0131 31.9026 39.9993 30.6872V9.28835C40.0149 8.06913 39.7863 6.85911 39.3269 5.72965C38.8675 4.60018 38.1867 3.57412 37.3245 2.71197C36.4611 1.84542 35.434 1.15937 34.3028 0.693799C33.1717 0.228227 31.9592 -0.00755787 30.736 0.000184676Z"
                    fill="var(--color2, #BC0051)"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_442_203">
                    <rect width="40" height="40" rx="10" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </li>
          <li class="footer__links_item">
            <a
              href="https://www.linkedin.com/company/unco-club"
              target="_blank"
              class="svg-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                class="svg-icon"
              >
                <path
                  d="M27.0408 10.0409C25.9948 8.84633 25.4182 7.31247 25.4184 5.72461H20.6888V24.7042C20.6531 25.7315 20.2197 26.7048 19.4801 27.4187C18.7404 28.1327 17.7524 28.5314 16.7245 28.5307C14.551 28.5307 12.7449 26.7552 12.7449 24.5511C12.7449 21.9185 15.2857 19.944 17.9031 20.7552V15.9185C12.6224 15.2144 8 19.3164 8 24.5511C8 29.6481 12.2245 33.2756 16.7092 33.2756C21.5153 33.2756 25.4184 29.3726 25.4184 24.5511V14.9236C27.3362 16.3009 29.6388 17.0399 32 17.0358V12.3062C32 12.3062 29.1224 12.444 27.0408 10.0409Z"
                  fill="var(--color1, #FEFFFA)"
                />
                <path
                  d="M30.625 0H9.375C4.19733 0 0 4.19733 0 9.375V30.625C0 35.8027 4.19733 40 9.375 40H30.625C35.8027 40 40 35.8027 40 30.625V9.375C40 4.19733 35.8027 0 30.625 0Z"
                  fill="var(--color2, #BC0051)"
                />
                <path
                  d="M27.0408 10.0409C25.9948 8.84633 25.4182 7.31247 25.4184 5.72461H20.6888V24.7042C20.6531 25.7315 20.2197 26.7048 19.4801 27.4187C18.7404 28.1327 17.7524 28.5314 16.7245 28.5307C14.551 28.5307 12.7449 26.7552 12.7449 24.5511C12.7449 21.9185 15.2857 19.944 17.9031 20.7552V15.9185C12.6224 15.2144 8 19.3164 8 24.5511C8 29.6481 12.2245 33.2756 16.7092 33.2756C21.5153 33.2756 25.4184 29.3726 25.4184 24.5511V14.9236C27.3362 16.3009 29.6388 17.0399 32 17.0358V12.3062C32 12.3062 29.1224 12.444 27.0408 10.0409Z"
                  fill="var(--color1, #FEFFFA)"
                />
              </svg>
            </a>
          </li>
          <li class="footer__links_item">
            <a
              href="https://www.instagram.com/uff_eu"
              target="_blank"
              class="svg-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                class="svg-icon"
              >
                <path
                  d="M19.9968 15.9983C17.7933 15.9983 15.9951 17.7965 15.9951 20C15.9951 22.2035 17.7933 24.0017 19.9968 24.0017C22.2002 24.0017 23.9984 22.2035 23.9984 20C23.9984 17.7965 22.2002 15.9983 19.9968 15.9983ZM31.9987 20C31.9987 18.3429 32.0137 16.7008 31.9206 15.0467C31.8275 13.1254 31.3893 11.4202 29.9843 10.0153C28.5764 8.6073 26.8743 8.17201 24.953 8.07895C23.2959 7.98588 21.6539 8.00089 19.9998 8.00089C18.3427 8.00089 16.7006 7.98588 15.0465 8.07895C13.1253 8.17201 11.4201 8.6103 10.0152 10.0153C8.60729 11.4232 8.17201 13.1254 8.07894 15.0467C7.98588 16.7038 8.00089 18.3459 8.00089 20C8.00089 21.6541 7.98588 23.2992 8.07894 24.9533C8.17201 26.8746 8.61029 28.5798 10.0152 29.9847C11.4231 31.3927 13.1253 31.828 15.0465 31.9211C16.7036 32.0141 18.3457 31.9991 19.9998 31.9991C21.6569 31.9991 23.2989 32.0141 24.953 31.9211C26.8743 31.828 28.5794 31.3897 29.9843 29.9847C31.3923 28.5768 31.8275 26.8746 31.9206 24.9533C32.0167 23.2992 31.9987 21.6571 31.9987 20ZM19.9968 26.1572C16.5895 26.1572 13.8397 23.4073 13.8397 20C13.8397 16.5927 16.5895 13.8428 19.9968 13.8428C23.404 13.8428 26.1538 16.5927 26.1538 20C26.1538 23.4073 23.404 26.1572 19.9968 26.1572ZM26.406 15.0286C25.6105 15.0286 24.968 14.3862 24.968 13.5907C24.968 12.7951 25.6105 12.1527 26.406 12.1527C27.2015 12.1527 27.8439 12.7951 27.8439 13.5907C27.8442 13.7796 27.8071 13.9667 27.735 14.1412C27.6628 14.3158 27.5569 14.4744 27.4233 14.608C27.2897 14.7416 27.1311 14.8475 26.9565 14.9197C26.782 14.9918 26.5949 15.0289 26.406 15.0286Z"
                  fill="var(--color1, #FEFFFA)"
                />
                <path
                  d="M30.625 0H9.375C4.19733 0 0 4.19733 0 9.375V30.625C0 35.8027 4.19733 40 9.375 40H30.625C35.8027 40 40 35.8027 40 30.625V9.375C40 4.19733 35.8027 0 30.625 0Z"
                  fill="var(--color2, #BC0051)"
                />
                <path
                  d="M19.9968 15.9983C17.7933 15.9983 15.9951 17.7965 15.9951 20C15.9951 22.2035 17.7933 24.0017 19.9968 24.0017C22.2002 24.0017 23.9984 22.2035 23.9984 20C23.9984 17.7965 22.2002 15.9983 19.9968 15.9983ZM31.9987 20C31.9987 18.3429 32.0137 16.7008 31.9206 15.0467C31.8275 13.1254 31.3893 11.4202 29.9843 10.0153C28.5764 8.6073 26.8743 8.17201 24.953 8.07895C23.2959 7.98588 21.6539 8.00089 19.9998 8.00089C18.3427 8.00089 16.7006 7.98588 15.0465 8.07895C13.1253 8.17201 11.4201 8.6103 10.0152 10.0153C8.60729 11.4232 8.17201 13.1254 8.07894 15.0467C7.98588 16.7038 8.00089 18.3459 8.00089 20C8.00089 21.6541 7.98588 23.2992 8.07894 24.9533C8.17201 26.8746 8.61029 28.5798 10.0152 29.9847C11.4231 31.3927 13.1253 31.828 15.0465 31.9211C16.7036 32.0141 18.3457 31.9991 19.9998 31.9991C21.6569 31.9991 23.2989 32.0141 24.953 31.9211C26.8743 31.828 28.5794 31.3897 29.9843 29.9847C31.3923 28.5768 31.8275 26.8746 31.9206 24.9533C32.0167 23.2992 31.9987 21.6571 31.9987 20ZM19.9968 26.1572C16.5895 26.1572 13.8397 23.4073 13.8397 20C13.8397 16.5927 16.5895 13.8428 19.9968 13.8428C23.404 13.8428 26.1538 16.5927 26.1538 20C26.1538 23.4073 23.404 26.1572 19.9968 26.1572ZM26.406 15.0286C25.6105 15.0286 24.968 14.3862 24.968 13.5907C24.968 12.7951 25.6105 12.1527 26.406 12.1527C27.2015 12.1527 27.8439 12.7951 27.8439 13.5907C27.8442 13.7796 27.8071 13.9667 27.735 14.1412C27.6628 14.3158 27.5569 14.4744 27.4233 14.608C27.2897 14.7416 27.1311 14.8475 26.9565 14.9197C26.782 14.9918 26.5949 15.0289 26.406 15.0286Z"
                  fill="var(--color1, #FEFFFA)"
                />
              </svg>
            </a>
          </li>
        </ul>
      </div>
      <div class="footer__products">
        <h2 class="footer__products_title">
          {{ $t("footer.other_services") }}
        </h2>
        <ul class="footer__products_list">
          <li class="footer__products_item">
            <a
              href="https://unco.club/"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-link"
            >
              {{ $t("footer.uff_retail") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://unco.global/"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-link"
            >
              {{ $t("footer.uff_invest") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://unco.exchange/"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-link"
              >{{ $t("footer.unco_exchange") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://unco.group/"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-link"
              >{{ $t("footer.unco_nft") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://unco.bio"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-link"
              >{{ $t("footer.eco_points") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://foodfutures.net/"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_bloggers") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://unco.market/"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_communities") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://unco.eu/"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_farm_to_office") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://edaeco.club/"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_retired") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://foodfutures.net/"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-link"
            >
              {{ $t("footer.food_futures") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://unco.vc/"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_vc") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://rowfresh.com/"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_game") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://foodfutures.club/en"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_food_futures") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://unco.market"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_food_retail") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://uff.exchange/"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_academy") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://unco.market/Scanner"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_scanner") }}
            </a>
          </li>
          <li class="footer__products_item">
            <a
              href="https://unco.market"
              class="btn-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("footer.unco_shop") }}
            </a>
          </li>
        </ul>
      </div>
      <div class="footer__agreement">
        <a href="https://club.unco.market/files/Impressum.pdf">Imprint</a>
        <a href="https://club.unco.market/files/Datenschutz.pdf"
          >Data Protection</a
        >
        <!-- <a href="https://club.unco.market/files/Ru%CC%88ckgaberecht.pdf"
          >Return Policy</a
        > -->
        <a href="https://club.unco.market/files/AGB.pdf"
          >Terms and Conditions</a
        >
        <a href="https://www.unco.club/company/">About Us</a>
        <a href="https://www.unco.club/help/">How It Works</a>
        <a href="https://www.unco.club/company/reviews/"
          >Customer Testimonials</a
        >
      </div>
    </div>
    <div class="footer__info">
      <p class="footer__info_text">{{ $t("footer.disclaimer") }}</p>
      <p class="footer__info_text">{{ $t("footer.disclosure") }}</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
@import url("../assets/common-styles.css");

.footer {
  margin-top: 200px;
  width: 100%;
  background: #c7db8b;
  position: relative;
  box-sizing: border-box;
  overflow-x: clip;
}

.center-footer {
  padding-left: calc(50% - 670px);
  padding-right: calc(50% - 670px);
}

.footer__images {
  display: flex;

  position: absolute;

  width: 100%;
  align-items: flex-end;
  transform: translateY(-100%);
}
.footer__image_grass_1 {
  margin-left: 80px;
}
.footer__image_cart {
  margin-left: 90px;
}
.footer__image_grass_2 {
  margin-left: 130px;
}
.footer__image_grass_3 {
  margin-left: 380px;
}
.footer__image_grass_4 {
  margin-left: 240px;
}

.footer__main {
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  margin: 0;
  padding-top: 100px;
}

.footer__contacts {
  display: flex;
  flex-direction: column;
  max-width: 250px;
}
.footer__contact_info {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 40px;
}
.footer__contacts_list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.footer__contacts_title {
  color: #313131;
  font-family: Raleway;
  font-size: 20px;

  font-weight: 600;
  line-height: 133%;
}
.footer__contacts_text {
  color: #313131;
  font-family: Raleway;
  font-size: 18px;

  font-weight: 400;
  line-height: 133%;
}
.footer__links {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  max-width: 250px;
}
.footer__links_item a svg {
  fill: currentColor;
}
.svg-link {
  display: inline-block;
}
.svg-link:hover .svg-icon path {
  --color1: #214b33;
  --color2: #a2c33d;
}
.svg-link:hover rect {
  --color1: #214b33;
  --color2: #a2c33d;
}

.footer__products {
  display: flex;
  justify-content: center; /* Центрируем содержимое по горизонтали */
  align-items: flex-start;
  flex-direction: column;
}
.footer__products_title {
  color: #313131;
  font-family: Raleway;
  font-size: 20px;

  font-weight: 600;
  line-height: 133%;
  margin-bottom: 20px;
}
.footer__products_list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.btn-link {
  width: 462px;
  font-size: 20px;
  text-align: center;
}

.footer__agreement {
  display: flex;
  flex-direction: column;

  gap: 10px;
  color: #313131;
  font-family: Raleway;
  font-size: 16px;

  font-weight: 400;
  line-height: 166%;
}

.footer__info {
  padding: 50px 0 80px 130px;
}
.footer__info_text {
  font-family: Montserrat;
  color: #313131;
  font-size: 14px;
  margin-bottom: 30px;
  font-weight: 400;
  line-height: 166%;
  max-width: 1180px;
}

@media only screen and (max-width: 1439px) and (min-width: 768px) {
  .footer {
    margin-top: 235px;
    width: 100%;
    background: #c7db8b;
    position: relative;
  }

  .footer__images {
    display: flex;

    position: absolute;

    width: 100%;
    align-items: flex-end;

    padding-left: calc(50% - 384px);
    padding-right: calc(50% - 384px);
    transform: translateY(-100%);
  }
  .footer__image_grass_1 {
    margin-left: -15px;
  }
  .footer__image_cart {
    width: 250px;
    margin-left: -15px;
  }
  .footer__image_grass_2 {
    margin-left: 45px;
  }
  .footer__image_grass_3 {
    margin-left: 80px;
  }
  .footer__image_grass_4 {
    margin-left: 170px;
  }

  .footer__main {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;

    padding: 60px 30px 0 30px;
    margin: 0;
  }

  .footer__contacts {
    grid-area: 1 / 1 / 2 / 2;
    display: flex;
    gap: 50px;
  }
  .footer__contact_info {
    margin-bottom: 0px;
  }

  .footer__links {
    gap: 30px;
    max-width: 113px;
  }

  .footer__products {
    grid-area: 1 / 2 / 3 / 3;
  }

  .footer__agreement {
    grid-area: 2 / 1 / 3 / 2;
  }

  .footer__info {
    padding: 50px 30px 10px 30px;
  }
  .footer__info_text {
    font-family: Montserrat;
    color: #313131;
    font-size: 14px;
    font-weight: 400;
    line-height: 166%;
    margin-bottom: 50px;
  }
}

@media only screen and (max-width: 767px) {
  .footer {
    margin-top: 270px;
  }
  .center-footer {
    padding-left: calc(50% - 160px);
    padding-right: calc(50% - 160px);
  }

  .footer__images {
    width: 320px;
    transform: translateY(-100%);
  }
  .footer__image_grass_1 {
    margin-left: 0;
  }
  .footer__image_cart {
    width: 175px;
    margin-left: 50px;
  }
  .footer__image_grass_2 {
    margin-right: 0;
    margin-left: 0;
  }
  .footer__image_grass_3 {
    display: none;
  }
  .footer__image_grass_4 {
    display: none;
  }

  .footer__main {
    display: flex;
    flex-direction: column;
    gap: 50px;
    padding: 20px 10px 0;
    align-items: center;
  }

  .footer__contacts {
    order: 1;
    margin-bottom: 20px;
    padding-top: 60px;
  }
  .footer__contact_info {
    align-items: center;
  }
  .footer__contacts_title {
    align-self: flex-start;
  }
  .footer__links {
    margin-bottom: 20px;
    max-width: 250px;
    gap: 30px;
  }

  .footer__products {
    order: 2;
    margin-bottom: 20px;
  }
  .footer__products_title {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .btn-link {
    font-size: 24px;
    width: 300px;
  }

  .footer__agreement {
    order: 3;
    margin-left: 0;
  }

  .footer__info {
    padding: 50px 10px 30px 10px;
  }
  .footer__info_text {
    font-size: 14px;
    padding-bottom: 30px;
  }
}
</style>
